!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return i = {}, o.m = c = {
    0: function (e, t) {
      e.exports = r;
    },
    1: function (e, t) {
      e.exports = n;
    },
    747: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var t = r(0),
        n = r.n(t),
        t = r(1),
        r = r.n(t),
        t = function () {
          return n.a.createElement("g", {
            fill: "#00985F"
          }, n.a.createElement("path", {
            d: "M12.387 0v11.357c0 .52-.387.908-.903.908h-1.355c-.064 0-.129.065-.129.13v9.54c.323 0 .645.065 1.032.065C17.097 22 22 17.068 22 10.968 22 5.322 17.806.649 12.387 0zm-.258 17.003c-.774 0-1.355-.649-1.355-1.363 0-.779.645-1.363 1.355-1.363.774 0 1.355.65 1.355 1.363.064.714-.58 1.363-1.355 1.363zm3.226 0c-.774 0-1.355-.649-1.355-1.363 0-.779.645-1.363 1.355-1.363.774 0 1.355.65 1.355 1.363 0 .714-.581 1.363-1.355 1.363zm3.226 0c-.775 0-1.355-.649-1.355-1.363 0-.779.645-1.363 1.355-1.363.774 0 1.354.65 1.354 1.363 0 .714-.58 1.363-1.354 1.363z"
          }), n.a.createElement("path", {
            d: "M11 0C4.918 0 0 4.976 0 11.131 0 16.5 3.688 20.952 8.67 22V11.982c0-.458.389-.851.842-.917h1.359c.064 0 .129-.065.129-.13V0zM8.865 9.167c-.777 0-1.36-.655-1.36-1.375 0-.786.648-1.375 1.36-1.375.776 0 1.359.654 1.359 1.375 0 .72-.583 1.375-1.36 1.375z"
          }));
        };
      t.svg = {
        viewBox: "0 0 22 22"
      };
      var o = r()(t);
    }
  }, o.c = i, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 747);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return c[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var c, i;
});